import { 
  Form, 
  Input, 
  Button, 
  Select,
  Typography,
  Result,
  InputNumber,
  DatePicker
} from "antd";
import { useState } from "react";
import { useForm } from "antd/lib/form/Form";
import { signularisApi, useCreateMetaDocumentMutation, useGetRecipientsListQuery } from "../../../store/api/signularisApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useAppDispatch } from "../../../hooks/redux";
import genDocument6 from '../misc/gendoc6';
import { CREATE_DOCUMENT_ROUTE, MAIN_PAGE_ROUTE } from "../../../routing/consts";
import { Link } from "react-router-dom";
import { DocTemplateType } from "../../../types/types";
import { MinusCircleOutlined, PlusOutlined, SendOutlined } from "@ant-design/icons";
import style from '../CreateDocument.module.scss';

const { RangePicker } = DatePicker;
const { Item } = Form;
const { Option } = Select;

const vidZakupki = ['приобретение товара', 'оказание услуг', 'выполнение работ'];
const istochnikFinansirovaniya = ['Бюджетные средства', 'Внебюджетные средства'];
const poryadokOplati = ['поэтапная оплата', 'предоплата до 30%', 'постоплата'];

let guid = () => {
  let s4 = () => Math.floor((1 + Math.random()) * 0x100).toString(10).substring(1);
  return s4() + s4() + s4() + s4();
}

function styledDate() {
  const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"];
  const dobj = new Date();
  return `${dobj.getDate()} ${months[dobj.getMonth()]} ${dobj.getFullYear()}`;
}

function Template() {
  const info = useSelector((state: RootState) => state.userinfo);
  const dispatch = useAppDispatch();
  const { data: recipients } = useGetRecipientsListQuery();

  const defaulRepicients = ["6250271072944c7123ebdd53", "6639d5d8231c0c852d8b0e94", "6639d522231c0c852d8b0e93"];
  const recipientsList = recipients?.filter(item => !defaulRepicients.includes(item.id)) || [];

  const [docname, setDocname] = useState("");
  const [createMetaDocument, { isLoading: mutationLoading, isSuccess: mutationSuccess }] = useCreateMetaDocumentMutation();
  const [form] = useForm();

  const onFinish = async (values: any) => {
    const regnum = guid();
    setDocname('Заявка на приобретение ТРУ');
    const formData = new FormData();
    formData.append("title", `Заявка на приобретение ТРУ №${regnum}`);
    formData.append("brief", "Сгенерировано из шаблона");
    formData.append("recipients", values.recipients.join(","));
    formData.append("documentType", 'purchaseOfService');

    const templateValues = {
      ...values,
      regnum,
      regdate: styledDate(),
      dutyface: `${info.lastname} ${info.firstname} ${info.middlename}`
    };
    
    const pdfBytes = await genDocument6(templateValues, info);
    formData.append("file", new Blob([pdfBytes]));
    createMetaDocument(formData);
    dispatch(signularisApi.util.invalidateTags(['MetaDocument']));
  }

  if (mutationSuccess) {
    return (
      <Result
        status="success"
        title="Документ создан"
        subTitle={`Заявка на приобретение ТРУ успешно сформирована.`}
        extra={[
          <Link key="back" to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}>
            <Button type="primary">Создать еще</Button>
          </Link>
        ]}
      />
    )
  }

  return (
    <div className={style.generatorWrapper}>
      <h2 className={style.title}>Заявка на приобретение ТРУ</h2>
      <div className={style.alertInfo}>
        При создании заявки на приобретение товара/оказание услуг/выполнение работ, необходимо в получателях указать КУРИРУЮЩЕГО ПРОРЕКТОРА.
      </div>

      <Form form={form} onFinish={onFinish} layout="vertical">
        {/* Блок получателей */}
        <Item label="Получатели" name="recipients" rules={[{ required: true, message: 'Выберите получателей' }]}>
          <Select mode="multiple" placeholder="Выберите сотрудников..." size="large"
          allowClear
           filterOption={(input, option) =>
              (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
            }>
             {recipientsList?.map((recipient) => (
                                <Option key={recipient.id} value={recipient.id} label={recipient.fullname}>
                                {recipient.fullname} {!!recipient.position && <>- <span style={{color: 'gray', fontSize: 12}}>{recipient.position}</span></>}
                                </Option>
                            ))}
          </Select>
        </Item>

        <div className={style.recipientTags}>
          <span className={style.tag}>Минцаев Магомед Шавалович</span>
          <span className={style.tag}>Гуржиханов Аслан Юсуп-Хаджиевич</span>
          <span className={style.tag}>Батаева Маднат Карим-Султановна</span>
        </div>

        {/* Основные параметры закупки */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <Item label="Вид закупки" name="vidZakupki" rules={[{ required: true }]}>
            <Select placeholder="Выберите вид..." options={vidZakupki.map(e => ({ value: e, label: e }))} />
          </Item>
          <Item label="Источник финансирования" name="istochnikFinansirovaniya" rules={[{ required: true }]}>
            <Select placeholder="Выберите источник..." options={istochnikFinansirovaniya.map(e => ({ value: e, label: e }))} />
          </Item>
        </div>

        <Item label="Наименование и цель закупки" name="nameZakupki" rules={[{ required: true }]}>
          <Input placeholder="Напр: Закупка оборудования для лаборатории" />
        </Item>

        {/* Цена */}
        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-end' }}>
          <Item label="Начальная максимальная цена (руб)" name="maxPriceRub" rules={[{ required: true }]} style={{ flex: 1 }}>
            <InputNumber style={{ width: '100%' }} placeholder="0" />
          </Item>
          <Item label="Копейки" name="maxPriceKopeck" rules={[{ required: true }]} style={{ width: '120px' }}>
            <InputNumber style={{ width: '100%' }} placeholder="00" maxLength={2} />
          </Item>
        </div>

        {/* Дополнительные поля */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <Item label="Форма закупки" name="formaZakupki">
            <Input placeholder="Форма закупки" />
          </Item>
          <Item label="Номер телефона" name="phone">
            <Input placeholder="+7 (___) ___-__-__" />
          </Item>
        </div>

        {/* Техническое задание */}
        <h3 style={{ margin: '24px 0 16px', fontWeight: 700, borderBottom: '1px solid #f1f5f9', paddingBottom: '8px' }}>
          Техническое задание
        </h3>

        <Item label="Наименование и цель закупки" name="tehNameZakupki" rules={[{ required: true }]}>
          <Input placeholder="Наименование и цель закупки" />
        </Item>

        {/* Динамический список ТРУ */}
        <div className={style.dynamicList}>
          <Form.List name="tru">
            {(fields, { add, remove }) => (
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                  <span style={{ fontWeight: 700, color: '#475569' }}>Перечень товаров / услуг</span>
                  <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>Добавить позицию</Button>
                </div>
                
                {fields.map(({ key, name, ...restField }, index) => (
                  <div key={key} style={{ background: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '16px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                      <span className={style.tag}>Позиция №{index + 1}</span>
                      <Button type="text" danger onClick={() => remove(name)} icon={<MinusCircleOutlined />} />
                    </div>
                    
                    <Item {...restField} name={[name, 'name']} rules={[{ required: true }]} label="Наименование ТРУ">
                      <Input placeholder="Что закупаем?" />
                    </Item>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <Item {...restField} name={[name, 'count']} label="Количество" rules={[{ required: true }]}>
                        <InputNumber style={{ width: '100%' }} placeholder="0" />
                      </Item>
                      <Item {...restField} name={[name, 'price']} label="Цена за ед. (руб)" rules={[{ required: true }]}>
                        <InputNumber style={{ width: '100%' }} placeholder="0.00" />
                      </Item>
                    </div>
                  </div>
                ))}
              </>
            )}
          </Form.List>
        </div>

        {/* Финальные поля */}
        <Item label="Место (поставки товара/оказания услуг/выполнения работ)" name="tehMesto">
          <Input placeholder="Напр: г. Грозный, ул. Исаева, 100" />
        </Item>

        <Item label="Сроки (периоды) поставки товара/оказания услуг/выполнения работ" name="tehSroki">
          <RangePicker style={{ width: '100%' }} placeholder={['Начало', 'Конец']} />
        </Item>

        <Item label="Порядок оплаты" name="tehPoryadokOplati">
          <Select placeholder="Выберите вариант..." options={poryadokOplati.map(e => ({ value: e, label: e }))} />
        </Item>

        <Item label="Иные требования к работам и условиям их выполнения по усмотрению заказчика (для включения в договор)" name="tehInieTrebovaniya">
          <Input.TextArea placeholder="Дополнительные условия для включения в договор" />
        </Item>

        <Button 
          type="primary" 
          htmlType="submit" 
          loading={mutationLoading}
          size="large"
          icon={<SendOutlined />}
          style={{ width: '100%', marginTop: '24px' }}
        >
          Сформировать и отправить заявку
        </Button>
      </Form>
    </div>
  );
}

export default Template;
